import img_0 from "./avif/1.avif"
import img_1 from "./avif/2.avif"
import img_2 from "./avif/3.avif"
import img_3 from "./avif/4.avif"
import img_4 from "./avif/5.avif"
import img_5 from "./avif/6.avif"
import img_6 from "./avif/7.avif"
import img_7 from "./avif/8.avif"
import img_8 from "./avif/9.avif"
import img_9 from "./avif/10.avif"
import img_10 from "./avif/11.avif"
import img_11 from "./avif/12.avif"
import img_12 from "./avif/13.avif"
import img_13 from "./avif/14.avif"
import img_14 from "./avif/15.avif"
import img_15 from "./avif/16.avif"
import img_16 from "./avif/17.avif"
import img_17 from "./avif/18.avif"
import img_18 from "./avif/19.avif"
import img_19 from "./avif/20.avif"
import img_20 from "./avif/21.avif"
import img_21 from "./avif/22.avif"
import img_22 from "./avif/23.avif"
import img_23 from "./avif/24.avif"
import img_24 from "./avif/25.avif"
import img_25 from "./avif/26.avif"
import img_26 from "./avif/27.avif"
import img_27 from "./avif/28.avif"
import img_28 from "./avif/29.avif"
import img_29 from "./avif/30.avif"
import img_30 from "./avif/31.avif"
import img_31 from "./avif/32.avif"
import img_32 from "./avif/33.avif"
import img_33 from "./avif/34.avif"
import img_34 from "./avif/35.avif"
import img_35 from "./avif/36.avif"
import img_36 from "./avif/37.avif"
import img_37 from "./avif/38.avif"
import img_38 from "./avif/39.avif"
import img_39 from "./avif/40.avif"
import img_40 from "./avif/41.avif"
import img_41 from "./avif/42.avif"
import img_42 from "./avif/43.avif"
import img_43 from "./avif/44.avif"
import img_44 from "./avif/45.avif"
import img_45 from "./avif/46.avif"
import img_46 from "./avif/47.avif"
import img_47 from "./avif/48.avif"
import img_48 from "./avif/49.avif"
import img_49 from "./avif/50.avif"
import img_50 from "./avif/51.avif"
import img_51 from "./avif/52.avif"
import img_52 from "./avif/53.avif"
import img_53 from "./avif/54.avif"
import img_54 from "./avif/55.avif"
import img_55 from "./avif/56.avif"
import img_56 from "./avif/57.avif"
import img_57 from "./avif/58.avif"
import img_58 from "./avif/59.avif"
import img_59 from "./avif/60.avif"
import img_60 from "./avif/61.avif"
import img_61 from "./avif/62.avif"
import img_62 from "./avif/63.avif"
import img_63 from "./avif/64.avif"
import img_64 from "./avif/65.avif"
import img_65 from "./avif/66.avif"
import img_66 from "./avif/67.avif"
import img_67 from "./avif/68.avif"
import img_68 from "./avif/69.avif"
import img_69 from "./avif/70.avif"
import img_70 from "./avif/71.avif"
import img_71 from "./avif/72.avif"
import img_72 from "./avif/73.avif"
import img_73 from "./avif/74.avif"
import img_74 from "./avif/75.avif"
import img_75 from "./avif/76.avif"
import img_76 from "./avif/77.avif"
import img_77 from "./avif/78.avif"
import img_78 from "./avif/79.avif"
import img_79 from "./avif/80.avif"
import img_80 from "./avif/81.avif"
import img_81 from "./avif/82.avif"
import img_82 from "./avif/83.avif"
import img_83 from "./avif/84.avif"
import img_84 from "./avif/85.avif"
import img_85 from "./avif/86.avif"
import img_86 from "./avif/87.avif"
import img_87 from "./avif/88.avif"
import img_88 from "./avif/89.avif"
import img_89 from "./avif/90.avif"
import img_90 from "./avif/91.avif"
import img_91 from "./avif/92.avif"
import img_92 from "./avif/93.avif"
import img_93 from "./avif/94.avif"
import img_94 from "./avif/95.avif"
import img_95 from "./avif/96.avif"
import img_96 from "./avif/97.avif"
import img_97 from "./avif/98.avif"
import img_98 from "./avif/99.avif"
import img_99 from "./avif/100.avif"
import img_100 from "./avif/101.avif"
import img_101 from "./avif/102.avif"
import img_102 from "./avif/103.avif"
import img_103 from "./avif/104.avif"

var images = []

images[0] = img_0
images[1] = img_1
images[2] = img_2
images[3] = img_3
images[4] = img_4
images[5] = img_5
images[6] = img_6
images[7] = img_7
images[8] = img_8
images[9] = img_9
images[10] = img_10
images[11] = img_11
images[12] = img_12
images[13] = img_13
images[14] = img_14
images[15] = img_15
images[16] = img_16
images[17] = img_17
images[18] = img_18
images[19] = img_19
images[20] = img_20
images[21] = img_21
images[22] = img_22
images[23] = img_23
images[24] = img_24
images[25] = img_25
images[26] = img_26
images[27] = img_27
images[28] = img_28
images[29] = img_29
images[30] = img_30
images[31] = img_31
images[32] = img_32
images[33] = img_33
images[34] = img_34
images[35] = img_35
images[36] = img_36
images[37] = img_37
images[38] = img_38
images[39] = img_39
images[40] = img_40
images[41] = img_41
images[42] = img_42
images[43] = img_43
images[44] = img_44
images[45] = img_45
images[46] = img_46
images[47] = img_47
images[48] = img_48
images[49] = img_49
images[50] = img_50
images[51] = img_51
images[52] = img_52
images[53] = img_53
images[54] = img_54
images[55] = img_55
images[56] = img_56
images[57] = img_57
images[58] = img_58
images[59] = img_59
images[60] = img_60
images[61] = img_61
images[62] = img_62
images[63] = img_63
images[64] = img_64
images[65] = img_65
images[66] = img_66
images[67] = img_67
images[68] = img_68
images[69] = img_69
images[70] = img_70
images[71] = img_71
images[72] = img_72
images[73] = img_73
images[74] = img_74
images[75] = img_75
images[76] = img_76
images[77] = img_77
images[78] = img_78
images[79] = img_79
images[80] = img_80
images[81] = img_81
images[82] = img_82
images[83] = img_83
images[84] = img_84
images[85] = img_85
images[86] = img_86
images[87] = img_87
images[88] = img_88
images[89] = img_89
images[90] = img_90
images[91] = img_91
images[92] = img_92
images[93] = img_93
images[94] = img_94
images[95] = img_95
images[96] = img_96
images[97] = img_97
images[98] = img_98
images[99] = img_99
images[100] = img_100
images[101] = img_101
images[102] = img_102
images[103] = img_103

var top_reset = true;
var bottom_reset = true;

const scrollFrames = {
    defaults: {
        style: {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center'
        }
    },
    // Intersection
    // @el - object - The DOM object to detect
    // Returns float between 0 and 1
    // value == 0 means the element is not visible yet
    // value between 0 and 1 means the element is currently visible into the viewport
    // 0 means the element starts into the viewport
    // 1 means the element has just finished to run through the viewport
    // value == 1 means the element has past the viewport is not visible anymore
    getIntersection: function(el) {
        let response = -1;
        if (typeof el == 'object') {
            const detector_id = el.dataset.detector;
            if (detector_id !== undefined) {
                const el_detector = document.getElementById(detector_id);
                if (el_detector !== null) {
                    el = el_detector;
                }
            }
            if (typeof el.getBoundingClientRect == 'function') {
                const box = el.getBoundingClientRect();
                const el_offset_top = box.top + window.pageYOffset - document.documentElement.clientTop;
                const el_height = el.clientHeight;
                const window_scroll_top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                const window_height = window.document.documentElement.clientHeight;
                response = (window_scroll_top + window_height - el_offset_top) / (window_height + el_height) / 4;
            }
        }
        // Limits between 0 and 1
        if (response > 1) {
            response = 1;
        }
        if (response < 0) {
            response = 0;
        }
        return response;
    },
    anims: {},
    // Set up the animations
    update: function() {
        // Scan for instances
        let elems_anims = document.querySelectorAll('[scroll-frames]');
        if (elems_anims !== null) {
            elems_anims.forEach(function(el_anim) {
                // Get the anim ID
                const anim_id = el_anim.getAttribute('scroll-frames');
                // Get the URL mask
                const anim_url_mask = el_anim.dataset.urlMask;
                // Get the JSON URL
                const anim_json_url = el_anim.dataset.json;
                // Get the anim keyframes
                let anim_keyframes = el_anim.dataset.keyframes;
                // Set default keyframes if unset
                if (anim_keyframes === undefined) {
                    anim_keyframes = '0:0 to 100:100';
                }

                // Check id validity
                if (anim_id.length > 0 && anim_id !== undefined) {
                    // Init instance before fetch
                    scrollFrames.anims[anim_id] = {
                        ready: false,
                        transfer: false,
                        backgroundImage: '',
                        backgroundSizes: []
                    }
                    // Mask
                    // console.log(img_0)
                    if (anim_url_mask !== undefined && anim_json_url === undefined) {
                        const anim_mask_array = anim_url_mask.split('|');
                        if (anim_mask_array.length == 3) {
                            const anim_mask_interval = anim_mask_array[1].split(' to ');
                            const anim_mask_i_start = parseInt(anim_mask_interval[0]);
                            const anim_mask_i_end = parseInt(anim_mask_interval[1]);
                            let json_from_mask = [];
                            // console.log(anim_mask_i_start,anim_mask_i_end);
                            for (let frame_index = anim_mask_i_start; frame_index <= anim_mask_i_end; frame_index++) {
                                json_from_mask.push({
                                    url: images[frame_index - 1]
                                    // url: eval(this["img_".toString() + (frame_index - 1)]),
                                });
                                // console.log(eval(this["img_".toString() + (frame_index - 1)]))
                            }
                            // console.log(json_from_mask)
                            scrollFrames.build(json_from_mask, el_anim, anim_id, anim_keyframes);
                        }
                    }
                    // Test if valid JSON URL
                    if (anim_json_url !== undefined && anim_url_mask === undefined) {
                        if (anim_json_url.indexOf('.json') == anim_json_url.length - 5) {
                            // Let's fetch
                            fetch(anim_json_url).then(function(response) {
                                const contentType = response.headers.get("content-type");
                                if(contentType && contentType.indexOf("application/json") !== -1) {
                                    return response.json().then(function(json) {
                                        scrollFrames.build(json, el_anim, anim_id, anim_keyframes);
                                    });
                                } else {
                                    console.log(anim_json_url+" is not a valid JSON URL!");
                                }
                            });
                        }
                    }
                }
            });
        }
    },
    build: function(json, el_anim, anim_id, anim_keyframes) {
        // Background image string and background size object
        let backgroundImage = '';
        let backgroundSizes = [];
        // console.log(json);
        json.forEach(function(data, index) {
            backgroundImage += 'url('+data.url+')';
            if (index < json.length - 1) {
                backgroundImage += ',';
            }
            let backgroundSize = '';
            // Set background size value from this element or use default
            let backgroundSizeProperty = scrollFrames.defaults.style.backgroundSize;
            if (el_anim.dataset.backgroundSize !== undefined) {
                backgroundSizeProperty = el_anim.dataset.backgroundSize;
            }
            json.forEach(function(bsData, bsIndex) {
                if (bsIndex == index) {
                    backgroundSize += backgroundSizeProperty;
                } else {
                    backgroundSize += '0%';
                }
                if (bsIndex < json.length - 1) {
                    backgroundSize += ',';
                }
            });
            backgroundSizes.push(backgroundSize);
        });
        // Write the CSS multiple background-image property for this anim
        scrollFrames['anims'][anim_id]['backgroundImage'] = backgroundImage;
        // Write the CSS multiple background-size property for this anim
        scrollFrames['anims'][anim_id]['backgroundSizes'] = backgroundSizes;
        // Build the transfer function from keyframes
        scrollFrames['anims'][anim_id]['transfer'] = function(scroll_line) {
            let response = 0;
            if (typeof scroll_line == 'number') {
                // Keypoints
                if (anim_keyframes.indexOf(':') > 0) {
                    // example: 0:0 to 70:0 to 100:100
                    // console.log(anim_id);
                    const fromToArray = anim_keyframes.split(' to ');
                    let xa = 0;
                    let ya = fromToArray[0].split(':')[1];
                    let xb = 1;
                    let yb = 1;
                    // console.log(fromToArray);
                    fromToArray.forEach(function(keypoint, keyPointIndex) {
                        // If not last
                        if (keyPointIndex < fromToArray.length - 1) {
                            const positionCurrent = parseFloat(keypoint.split(':')[0]) / 100;
                            const positionNext = parseFloat(fromToArray[keyPointIndex + 1].split(':')[0]) / 100;

                            if (scroll_line >= positionCurrent && scroll_line <= positionNext) {
                                // console.log(positionCurrent, scroll_line, positionNext);
                                xa = positionCurrent;
                                ya = parseFloat(keypoint.split(':')[1]);
                                xb = positionNext;
                                yb = parseFloat(fromToArray[keyPointIndex + 1].split(':')[1]);
                            }
                        }
                    });
                    const coef = (yb - ya) / (xb - xa);
                    const y0 = yb - coef * xb;
                    response = (coef * scroll_line + y0) / 100;
                    // console.log(anim_id, response);
                    // console.log('scroll_line:'+scroll_line, 'yb:'+yb, 'ya:'+ya, 'xb:'+xb, 'xa:'+xa, 'response:'+response);
                }
            }
            return response;
        }
        // Write it is OK ready to be used
        scrollFrames['anims'][anim_id]['ready'] = true;
        // Write the DOM element
        scrollFrames['anims'][anim_id]['el'] = document.querySelector('[scroll-frames="'+anim_id+'"]');
        // If optional detector is set
        if (scrollFrames['anims'][anim_id]['el'] !== null) {
            const optional_detector_id = scrollFrames['anims'][anim_id]['el'].dataset.detector;
            if (optional_detector_id !== undefined) {
                const el_detector = document.getElementById(optional_detector_id);
                if (el_detector !== null) {
                    scrollFrames['anims'][anim_id]['el_detector'] = el_detector;
                }
            }
        }

        // Apply the background-image property on element
        el_anim.style.backgroundImage = scrollFrames['anims'][anim_id]['backgroundImage'];
        // Apply other style properties
        Object.keys(scrollFrames.defaults.style).forEach(function(property) {
            // If CSS property is set through dataset on el_anim, use it
            if (el_anim.dataset[property] !== undefined) {
                el_anim.style[property]  = el_anim.dataset[property];
            }
            // Otherwise use default
            else {
                el_anim.style[property]  = scrollFrames.defaults.style[property];
            }
        });
        // Start
        scrollFrames.frame();
        // Apply listener
        window.addEventListener('scroll', scrollFrames.raf);
    },
    raf: function() {
        window.requestAnimationFrame(scrollFrames.frame);
    },
    frame: function() {
        // Scan all anims ids
        Object.keys(scrollFrames.anims).forEach(function(anim_id, anim_index) {
            // If current anim is ready
            if (scrollFrames['anims'][anim_id]['ready'] && scrollFrames['anims'][anim_id]['el'] !== null) {
                let current_scroll_line = 0;
                if (scrollFrames['anims'][anim_id]['el_detector'] !== null && scrollFrames['anims'][anim_id]['el_detector'] !== undefined) {
                    current_scroll_line = scrollFrames.getIntersection(scrollFrames['anims'][anim_id]['el_detector']);
                } else {
                    current_scroll_line = scrollFrames.getIntersection(scrollFrames['anims'][anim_id]['el']);
                }
                const frameIndex = scrollFrames['anims'][anim_id]['transfer'](current_scroll_line);
                if (frameIndex > 0.99 && !bottom_reset) {
                    top_reset = true;
                    window.scrollTo(0, document.body.scrollHeight / 2 * 0.01)
                }
                else if (frameIndex < 0.01 && !top_reset) {
                    bottom_reset = true;
                    window.scrollTo(0, document.body.scrollHeight / 2 * 0.99)
                }
                else if (frameIndex >= 0.02 && frameIndex <= 0.98) {
                    bottom_reset = false;
                    top_reset = false;
                }
                // console.log(frameIndex);
                const index = Math.round(frameIndex * (scrollFrames['anims'][anim_id]['backgroundSizes'].length - 1));
                // console.log(anim_id, current_scroll_line, frameIndex);
                // Apply proper background-size property
                // console.log(scrollFrames['anims'])

                scrollFrames['anims'][anim_id]['el']['style']['background-size'] = scrollFrames['anims'][anim_id]['backgroundSizes'][index];
            }
        });
    }
}
scrollFrames.update();
